import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Subject, takeUntil } from 'rxjs';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-lista-multimedia',
  templateUrl: './lista-multimedia.component.html',
  styleUrls: ['./lista-multimedia.component.scss'],
})
export class ListaMultimediaComponent implements OnInit, OnDestroy {
  private _unsubscribeOnDestroy$: Subject<boolean> = new Subject<boolean>();
  loading: boolean = true;
  s3ServiceRoute: any = `${environment.alimentosBebidasApi}/api/v1`;
  multimedia: any = null;
  isthereChanges: boolean = false;
  pdfViewer: any = false;
  index: any;
  url: any;

  constructor(
    private readonly sanitizer: DomSanitizer,
    private readonly http: HttpClient,
    public dialogRef: MatDialogRef<ListaMultimediaComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    // this.multimedia = this.data.miarchivo;
  }

  ngOnInit(): void {
    this.obtenerArchivoConSubscribe(this.data.id);
  }

  ngOnDestroy(): void {
    this._unsubscribeOnDestroy$.next(true);
    this.onCancel();
    this._unsubscribeOnDestroy$.complete();
  }

  obtenerArchivoConSubscribe(id: string) {
    this.http
      .get(`${this.s3ServiceRoute}/getFileOrdenSalida/${id}`)
      .pipe(takeUntil(this._unsubscribeOnDestroy$))
      .subscribe({
        next: (res: any) => {
          let binary = '';
          let bytes = new Uint8Array(res.data);
          let len = bytes.byteLength;
          for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
          }

          this.multimedia =
            this.sanitizer.bypassSecurityTrustResourceUrl(binary);
          this.loading = false;
        },
        error: () => {
          this.multimedia = null;
          this.loading = false;
        },
      });
  }

  getBase64 = (file: any, cb: any) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) {};
  };

  onFileSelected(event: any) {
    if (event.target.files) {
      for (let i = 0; i < event.target.files?.length; i++) {
        const file = event.target.files[i];

        const allowedTypes = [
          'application/pdf',
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'image/jpeg',
          'image/png',
        ];

        if (allowedTypes.includes(file.type)) {
          this.getBase64(file, (result: any) => {
            const image = {
              src: result,
              name: file.name,
              nameDownload: file.name,
            };

            this.multimedia.push(image);
          });
          //
          // });
        } else {
          Swal.fire({
            position: 'top-end',
            icon: 'error',
            title: 'Error al subir',
            text: `Este formato no está soportado: ${file.name}`,
            showConfirmButton: false,
            timer: 4000,
          });
        }
      }
    }
  }

  onCancel() {
    this.dialogRef.close({
      multimedia: this.multimedia,
      isthereChanges: this.isthereChanges,
    });
  }

  activatePDF(multimedia: any) {
    this.pdfViewer = !this.pdfViewer;

    // this.url = this.sanitizer.bypassSecurityTrustResourceUrl(multimedia.src);
  }
}
